import React, { useState } from "react"
import styled from "styled-components"
import Scene from "../scene"
import Figure from "../figure"
import Video from "../../video/Video"
import Caption from "../styled/caption"
import StickySlide from "../../StickySlide"

const Mabani = () => {
  
  const [sceneIndex, setSceneIndex] = useState(0);

  const steps = [
    {
      caption: "Al Mabani was constructed on the site of an old storage depot, in a section of Tripoli controlled by a powerful militia."
    },
    {
      caption: "The prison held some fifteen hundred migrants in eight cells, segregated by gender."
    },
    {
      caption: "Troublemakers were taken to the “isolation room,” an abandoned gas station, where they were hung from the ceiling and beaten."
    },
    {
      caption: "Candé was put in Cell No. 4, along with some three hundred other migrants.",
      captionPosition: "center-left"
    },
    {
      caption: "Representatives from an aid group estimated that there were three migrants per square metre.",
      captionPosition: "center-left"
    }
    //Detainees fought over who could sleep in the shower, which had better ventilation.
  ];

  return (
    <StyledMabaniLayout>
      <StyledMabaniBackground className={`step-${sceneIndex}`}>
        <div className="is-active">
          <img src={"/investigations/the-secretive-libyan-prisons-that-keep-migrants-out-of-europe/images/layout-mabani.svg"} alt="" />
        </div>
        <div className={sceneIndex === 1 ? 'is-active' : undefined}>
          <img src={"/investigations/the-secretive-libyan-prisons-that-keep-migrants-out-of-europe/images/layout-mabani-labels.svg"}  alt="" />
        </div>
        <div className={sceneIndex === 2 ? 'is-active' : undefined}>
          <img src={"/investigations/the-secretive-libyan-prisons-that-keep-migrants-out-of-europe/images/layout-mabani-label-isolation-room.svg"}  alt="" />
        </div>
        <div className={sceneIndex === 3 || sceneIndex === 4 ? 'is-active' : undefined}>
          <img src={"/investigations/the-secretive-libyan-prisons-that-keep-migrants-out-of-europe/images/layout-mabani-cell-4.svg"}  alt="" />
        </div>
        <div className={sceneIndex === steps.length ? 'is-active' : undefined}></div>
      </StyledMabaniBackground>
      {steps.map(( step, stepIndex) => (
        <StickySlide key={`mabani-scene-${stepIndex}`} customMarginTop="-100vh" fadeIn={stepIndex === 0 ? "false" : undefined} sceneIndex={stepIndex} setSceneIndex={setSceneIndex} captionPosition="bottom-left">
          {step.caption && (
            <Caption>{step.caption}</Caption>
          )}
        </StickySlide>
      ))}
      <Scene fadeOut="false" isDark="true" customMarginTop="-100vh" sceneIndex={steps.length} setSceneIndex={setSceneIndex}>
        <Figure
          caption="Footage of conditions inside Cell No. 3, from October, 2021."
          maxWidth="16em"
          maxWidthMobile="12em"
        >
          <Video
            src="https://cdn.theoutlawocean.com/al-mabani/footage__al-mabani.mp4"
            customPadding="178.26%"
            autoplay="autoplay"
            muted="muted"
            loop="loop"
          />
        </Figure>
      </Scene>
    </StyledMabaniLayout>
  )
};
export default Mabani;
export { Mabani };

const StyledMabaniLayout = styled.div`
  position: relative;
  background-color: var(--theme-background-light);
  width: 100vw;
  left: 50%;
  margin: calc(3 * var(--text-size)) 0;
  margin-left: -50vw;
  @media ( max-width: 48em ) {
    text-align: center;
  }
`

const StyledMabaniBackground = styled.div`
  position: sticky;
  top: 0;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  mix-blend-mode: multiply;
  transform: translate3d(0,0,0);
  > div {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: transform 1s cubic-bezier(0.76, 0, 0.24, 1), opacity 0.3s ease;
    transform: translate3d(0,0,0);
    will-change: transform, opacity;
    opacity: 0;
    &.is-active {
      opacity: 1;
      transition: transform 1s cubic-bezier(0.76, 0, 0.24, 1), opacity 0.3s ease 0.2s;
    }
    > img {
      position: absolute;
      display: block;
      top: 50%;
      left: 50%;
      height: 400%;
      width: auto;
      max-width: none;
      object-fit: cover;
      transform: translate3d(-50%,-50%,0) scale(0.25);
    }
  }
  &.step-2 > div {
    transform: translate3d(-30%,-30%,0) scale(1.6);
  }
  &.step-3 > div,
  &.step-4 > div,
  &.step-5 > div {
    transform: translate3d(-70%,-5%,0) scale(3.25);
  }
  &.step-3 > div:first-of-type,
  &.step-4 > div:first-of-type,
  &.step-5 > div:first-of-type {
    opacity: 0.05;
  }
  > div:last-of-type {
    background-color: var(--theme-background-dark);
  }

  @media ( max-width: 48em ) {
    > div {
      bottom: auto;
      padding-bottom: 120%;
      transform: translate3d(-10%,0,0);
      img {
        object-position: right center;
      }
    }
    &.step-2 > div {
      transform: translate3d(-70%,-30%,0) scale(1.6);
    }
    &.step-3 > div,
    &.step-4 > div,
    &.step-5 > div {
      transform: translate3d(-158%,0,0) scale(3.5);
    }
    > div:last-of-type {
      transform: translate3d(0,0,0);
      padding-bottom: 0;
      bottom: 0;
    }
  }
`
